function mainAnimate() {
  const scriptTag = document.querySelector("[data-animate-script]");
  if (!scriptTag) {
    console.warn("Warning: the <script> with data-animate-script attribute not found.");
    return;
  }

  if (scriptTag.defer || scriptTag.async) {
    console.warn("Warning: the <script> tag must not include async or defer attributes.", scriptTag);
    return;
  }

  const wrapper = document.querySelector(scriptTag.dataset.animateWrapper);
  if (!wrapper) return;

  wrapper.classList.add("animate-initialized");

  const elementSelector = "[data-animate]";

  const intersectionObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("animate-intersected");
          intersectionObserver.unobserve(entry.target);
        }
      });
    },
    {
      rootMargin: "-50px",
    }
  );

  const mutationObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE && node.matches(elementSelector)) {
          intersectionObserver.observe(node);
        }
      });
    });
  });

  mutationObserver.observe(wrapper, {
    childList: true,
    subtree: true,
  });
}

mainAnimate();
